import { Outlet } from 'react-router-dom';

function PointHistoryPage() {
  return <Outlet />;
}

export default PointHistoryPage;
